import { Tooltip, Zoom, IconButton } from '@material-ui/core';
import { Delete as DeleteIcon } from '@material-ui/icons';


interface IProps {
    size?: 'small' | 'medium'
    stopPropagation?: boolean
    onClick: () => void
}

let DeleteIconButton = ({ size = 'small', stopPropagation, onClick }: IProps) => {
    return (
        <Tooltip title="Delete" TransitionComponent={Zoom}>
            <IconButton
                size={size}
                color="secondary"
                onClick={ev => {
                    if (stopPropagation === true) {
                        ev.stopPropagation();
                    }
                    onClick();
                }}
            >
                <DeleteIcon />
            </IconButton>
        </Tooltip>
    )
}

export default DeleteIconButton;